import { render, staticRenderFns } from "./BindsCardExpand.vue?vue&type=template&id=a7df27d8&"
import script from "./BindsCardExpand.vue?vue&type=script&lang=js&"
export * from "./BindsCardExpand.vue?vue&type=script&lang=js&"
import style0 from "./BindsCardExpand.vue?vue&type=style&index=0&id=a7df27d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports